import { render, staticRenderFns } from "./_Header-action.vue?vue&type=template&id=47b07418&scoped=true&"
import script from "./_Header-action.vue?vue&type=script&lang=js&"
export * from "./_Header-action.vue?vue&type=script&lang=js&"
import style0 from "./_Header-action.vue?vue&type=style&index=0&id=47b07418&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b07418",
  null
  
)

export default component.exports